import { render, staticRenderFns } from "./VStepContent.vue?vue&type=template&id=511a1284&"
import script from "./VStepContent.vue?vue&type=script&lang=js&"
export * from "./VStepContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports